<template>
    <CieloLayout :show-merchant-name="false" :starting-point-by-slot="false">
        <div class="shipping-address">
            <h4 class="shipping-address__title" v-text="$ml.get('shippingAddressInfo')" tabindex="0" />

            <Address
                :zip-code.sync="zipCode"
                :street.sync="street"
                :number.sync="number"
                :complement.sync="complement"
                :district.sync="district"
                :city.sync="city"
                :state.sync="state"
                :disable-street="disableStreet"
                :disable-district="disableDistrict"
                :disable-city="disableCity"
                :disable-state="disableState"
                :disable-number="disableNumber"
                :disable-complement="disableComplement"
                :disable-zip-code="disableZipCode"
                :address-errors.sync="addressErrors"
                :show-short-form="true"
                address-type="shippingAddress"
                @postalCodeFetched="onZipCodeFetched"
            />

            <h4 class="shipping-address__title" v-text="$ml.get('freightDefined')" tabindex="0" />

            <ShippingMethods />
        </div>


        <CieloButtonV2 :loading="buttonIsLoading" :disabled="!enableButton" @click="goToNextPage">
            <span :style="{ 'font-weight': 600 }" v-text="$ml.get('continue')" />
        </CieloButtonV2>
    </CieloLayout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);

import Swal from 'sweetalert2';
import Address from '@/components/Address';
import CieloButtonV2 from '../components/template/CieloButtonV2.vue';
import ShippingMethods from '@/components/ShippingMethods';
import { attr_accessor } from '@/services/VuexAcessor';
import { logEvent } from '@/helpers/cieloLogger';

export default {
    components: {
        CieloLayout,
        Address,
        CieloButtonV2,
        ShippingMethods,
    },

    data() {
        return {
            buttonIsLoading: false,
            addressErrors: {}
        };
    },

    computed: {
        ...mapGetters({
            methods: 'shippingType/getMethods',
            shippingType: 'shippingType/getType',
            shippingMethod: 'shippingType/getMethod'
        }),

        disableStreet: self => false,
        disableDistrict: self => false,
        disableCity: self => self.fetchedFields.includes('city'),
        disableState: self => self.fetchedFields.includes('state'),
        disableNumber: self => false,
        disableComplement: self => false,
        // disableZipCode: self => self.fetchedFields.includes('zipcode'),
        disableZipCode: self => false,

        /**
         * Dados a serem sincronizados com o storage
         */
        zipCode: attr_accessor(state => state.shippingAddress.ZipCode, 'shippingAddress/setZipCode'),
        street: attr_accessor(state => state.shippingAddress.Street, 'shippingAddress/setStreet'),
        number: attr_accessor(state => state.shippingAddress.Number, 'shippingAddress/setNumber'),
        complement: attr_accessor(state => state.shippingAddress.Complement, 'shippingAddress/setComplement'),
        district: attr_accessor(state => state.shippingAddress.District, 'shippingAddress/setDistrict'),
        city: attr_accessor(state => state.shippingAddress.City, 'shippingAddress/setCity'),
        state: attr_accessor(state => state.shippingAddress.State, 'shippingAddress/setState'),
        fetchedFields: {
            get: self => self.$store.state.shippingAddress.FetchedFields
        },

        enableButton() {
            if (this.addressErrors.items && this.addressErrors.items.length > 0)
                return false;

            if (!this.number) return false;

            if(!!!this.shippingMethod) return false;

            return true;
        },
    },

    methods: {
        async goToNextPage() {

			logEvent({
				category: 'checkout',
				action: 'endereço_entrega',
				label: 'Com o CEP, puxamos as informações do endereço, e usuário completa com número e complemento​'
			});

            this.buttonIsLoading = true;
            let isValid = await this.$validator.validate();
            if (!isValid) {
                this.buttonIsLoading = false;
                return;
            }

            if (!this.state) {
                this.buttonIsLoading = false;
                return await Swal.fire({
                    type: 'warning',
                    text: this.$ml.get('chooseYourState'),
                    confirmButtonText: this.$ml.get('addressUnderstood')
                });
            }

            try {
// Carrega os metódos de entrega se for correios ou loggi
                // 1 - Correios | 6 - Loggi
                if (this.shippingType == 1 || this.shippingType == 6)
                    await this.$store.dispatch('shippingType/calculateShipping');

                this.$store.dispatch('pipelineV2/pushNext');
            } catch {
                await Swal.fire({
                    type: 'error',
                    text: this.$ml.get('unableCalculateShippingCost'),
                    confirmButtonText: this.$ml.get('addressUnderstood'),
                });
            } finally {
                this.buttonIsLoading = false;
            }
        },

        onZipCodeFetched(response) {
            this.$store.commit('shippingAddress/ADDRESS_UPDATED', response.fields);
        },
    }
};
</script>

<style lang="scss" scoped>
.shipping-address {

    @media screen and (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        flex: 1 0 auto;
    }

    &__title {
        font-size: 16px;
        font-weight: 600;
        line-height: 16px;
        color: #2F363E;
        margin-bottom: 20px;
    }

    .address {
        flex: none;
        margin-bottom: 32px;
        @media screen and (min-width: 1025px) {
            margin-bottom: 12px;
        }

        &--short {
            margin-bottom: 12px;
            @media screen and (min-width: 1025px) {
                margin-bottom: 32px;
            }
        }
    }

    .selectCountry {
        display: none;
    }

    .shipping-methods__list {
        margin-bottom: 24px;
    }
}
</style>
